import { render, staticRenderFns } from "./OpenBadgesPage.vue?vue&type=template&id=e242599c"
import script from "./OpenBadgesPage.vue?vue&type=script&lang=js"
export * from "./OpenBadgesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports